
    import Vue from 'vue';
    import TabOne from './tabsClient/tab-oneClient.vue';
    import TabTwo from './tabsClient/tab-twoClient.vue';
    import { tabValidation, toViewModel } from '@/apps/shared/utils/NF';
    import { RouterLink } from 'vue-router'
    import FilePathService from '@/apps/shared/services/filePath-service';
    export default Vue.extend({
        components: {
            TabOne,
            TabTwo,
            RouterLink,
        },
        busEvents: {
            hiddenButton: function (btn) {
                if (btn == "Cotizar") {
                    document.getElementsByClassName("btn btn-lg btn btn-default cotizar")[0].id = btn
                    document.getElementById(btn).style.visibility = "hidden"
                }
                if (btn == "Siguiente") {
                    document.getElementsByClassName("btn btn-lg btn btn-default siguiente")[0].id = btn
                }
            }
        },
        name: 'ElectronicDeviceClientData',
        data() {
            return {
                capital: null,
                BreadcrumbText: "Datos personales",
                cover: null,
                stepOneData: null,
                stepTwoData: null,
                stepThreeData: null,
                activeStep: 0,
                localItems: [{ text: 'Inicio', path: '/electronic-equipment' }],
                wizard: {
                    showStepName: false,
                    type: NF.Wizard.Type.PILLS,
                    mode: NF.Wizard.Mode.STEP_BY_STEP,
                    validationMode: NF.Wizard.ValidationMode.ALWAYS,
                    buttons: {
                        final: { text: 'Contratar', class: 'btn btn-default cotizar' },
                        prev: { text: 'Anterior', class: 'btn btn-secondary-outline' },
                        next: { text: 'Siguiente', class: 'btn btn-default siguiente' }
                    },
                    footer: {
                        align: NF.Wizard.Footer.Align.SPACE_BETWEEN,
                    },
                    steps: [
                        {
                            displayName: '',
                            content: '#step1',
                            viewModel: toViewModel(TabOne),
                            validate: (config, direction) => tabValidation(config, direction),
                            onEnter: function () {
                                this.Bus.$emit('hiddenButton', 'Siguiente');
                                if (document.getElementsByClassName("btn btn-lg btn btn-secondary-outline disabled not-allowed").length > 0) {
                                    document.getElementsByClassName("btn btn-lg btn btn-secondary-outline disabled not-allowed")[0].className = "btn btn-lg btn btn-secondary-outline"
                                    'btn btn-lg btn btn-secondary-outline';
                                    document.getElementsByClassName("btn btn-lg btn btn-secondary-outline")[0].id = "Anterior";
                                    var botonAnterior = document.getElementById("Anterior") as HTMLButtonElement;
                                    botonAnterior.disabled = false;
                                }
                            },
                        },
                        {
                            displayName: '',
                            content: '#step2',
                            viewModel: toViewModel(TabTwo),
                            validate: (config, direction) => tabValidation(config, direction),
                            onEnter: function () {
                                window.globalThis.dataLayer.push({ 'product': 'tecnologia', 'event': 'cotizador-tecnologia-datos-equipo' });
                                document.getElementById("StepText").textContent = "Contratar";
                            },
                        },
                    ],
                },
            };
        },
        methods: {
            changeTitleAndIcon() {
                // Lógica para determinar el nuevo título
                const newTitle = 'Tecnología';
                // Emite eventos para actualizar el título
                this.$emit('updateTitle', newTitle);
            },

            updateByProductGoogleAnalytics() {
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                const productGtmName = 'DefaultElectronicDeviceGTMInfo';
                this.$emit('updateByProductGoogleAnalytics', productGtmName);
            },

            showFileError(errorMessage) {
                NF.Notification.show({
                    type: NF.Notification.Type.ERROR,
                    title: 'Error',
                    content: errorMessage,
                    position: NF.Notification.Positions.TOP_RIGHT,
                    clickClose: true,
                    autoHideDelay: 0
                })
            },
            open: function () {
                this.$refs.modal.open();
            },
            close: function () {
                this.$refs.modal.close();
            },
            getFilePath() {
                FilePathService.getFilePath("UrlBase")
                    .then(response => {
                        window.location.href = response + "electronic-equipment";
                    });
            },
        },

        mounted() {
            this.changeTitleAndIcon();
            this.updateByProductGoogleAnalytics();
            this.Bus.$on('step-one-data', (stepData) => this.stepOneData = stepData);
            this.Bus.$on('step-two-data', (stepData) => this.stepTwoData = stepData);
            var planDataSelected = sessionStorage.getItem("PlanSelected")
            var coverData = sessionStorage.getItem("cover");
            if (coverData != null) {
                this.cover = JSON.parse(coverData!)
                this.cobertura = this.cover
            }
            if (planDataSelected != null) {
                this.DataPlan = JSON.parse(planDataSelected!);
                window.globalThis.dataLayer.push({ 'product': 'tecnologia', 'event': 'cotizador-tecnologia-plan', 'plan': this.DataPlan.planDescription });
                this.planDescription = this.DataPlan.planDescription;
                this.primerCuota = this.DataPlan.premioMensual
                this.capital = this.DataPlan.capital

            }
        }
    })
